import axios from "axios";

// Resolve the backend URL at runtime so the same build works in BOTH preview
// and production. Backend and frontend live on the same custom domain in
// every Emergent environment (Kubernetes ingress routes /api/* to FastAPI),
// so the safest default is the current page origin. We only fall back to
// the build-time REACT_APP_BACKEND_URL if there is no browser window
// (server-side rendering / unit tests).
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : ENV_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const TOKEN_KEY = "gpthub.token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
